import { render } from "./Packouts.vue?vue&type=template&id=07a4a344"
import script from "./Packouts.vue?vue&type=script&lang=ts"
export * from "./Packouts.vue?vue&type=script&lang=ts"
script.render = render

export default script